import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import '../productPage/producthome.css';
import { Box } from '@mui/material';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import { useLocation, useNavigate } from 'react-router-dom';
import BreadCrumbs from '../common/BreadCrumbs';
import { useLocale } from '../../contexts/LocaleProvider';
import ToolPage from '../resourcesPage/simulationPage/ToolPage';
import TechnicalResources from '../automotivePage/TechnicalResources';
import ConsumerOverviewPage from './ConsumerOverviewPage';
import ReactiveBanner from '../common/ReactiveBanner';
import TabsComponent, { GetResponsiveWidth } from '../common/TabsComponent';
import { getTabTypography } from '../investorPage/investorRelationHome';
import { ApplicationsContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';
import { useSalesAndResourcesSimulationToolsContent } from '../../graphql/pimcore/modules/siteContent/hooks/useSalesAndResourcesSimulationToolsContent';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`product-tabpanel-${index}`}
            aria-labelledby={`product-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

interface ConsumerHomeProps {
    cmsContent: ApplicationsContent;
}

const ConsumerHome: FunctionComponent<ConsumerHomeProps> = ({ cmsContent }) => {
    const [value, setValue] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const [openMenu, setOpenMenu] = React.useState(false);
    const { contentTree: toolsContent } = useSalesAndResourcesSimulationToolsContent();

    const pathMap = useMemo(
        () => [
            '/applications/consumer/',
            '/applications/consumer/technical-resources',
            '/applications/consumer/simulation-tools',
        ],
        []
    );

    useEffect(() => {
        const newValue = pathMap.indexOf(location.pathname);
        setValue(newValue >= 0 ? newValue : 0);
    }, [location.pathname, pathMap]);

    const handleChange = (event: React.SyntheticEvent | null, newValue: number) => {
        setValue(newValue);
        const path = pathMap[newValue] ?? pathMap[0];
        if (path) {
            navigate(path);
        }
    };
    return (
        <div key={location.pathname} style={styles.productPageContainer}>
            <div style={styles.breadCrumbs}>
                <Box
                    sx={{
                        width: GetResponsiveWidth,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        margin: 'auto',
                    }}
                >
                    <BreadCrumbs navigationPath="/Home/Applications/Consumer" />
                </Box>
            </div>
            <ReactiveBanner
                title={cmsContent.Consumer.pageTitle.content}
                description={cmsContent.Consumer.pageSubtitle.content}
                bannerImage={cmsContent.Consumer.pageTitleBackgroundImage.imageUrl}
            />

            <Box sx={{ width: '100%', backgroundColor: '#7A7C81' }} data-testid={'outter_box'}>
                <TabsComponent
                    isMenuExpandMoreIcon
                    url={value}
                    setOpenMenu={setOpenMenu}
                    openMenu={openMenu}
                    handleChange={handleChange}
                    menuItems={[
                        { label: cmsContent.common.Overview.title.content, value: 0 },
                        { label: cmsContent.common.Resources.title.content, value: 1 },
                        { label: cmsContent.common.SimulationTools.title.content, value: 2 },
                    ]}
                    tabTypography={{
                        ...getTabTypography,
                    }}
                />

                <CustomTabPanel value={value} index={0}>
                    <ConsumerOverviewPage cmsContent={cmsContent.Consumer} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <TechnicalResources isAutomotive={false} backgroundColor={'white'} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <ToolPage cmsContent={toolsContent.Overview} />
                </CustomTabPanel>
            </Box>
        </div>
    );
};

export default ConsumerHome;
